import React from 'react';

import Content from '../../../Content';

import {IContentfulEmbeddedEntryProps} from './IContentfulEmbeddedEntry';

const ContentfulEmbeddedEntry = ({data}: IContentfulEmbeddedEntryProps): React.ReactElement => {
	return <Content data={data.target} />;
};

export default ContentfulEmbeddedEntry;
